module.exports = __webpack_public_path__ + "static/img/kh-18.5ea5124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-18.png
// module id = LeiN
// module chunks = 4